export default __webpack_public_path__ + "2b5b554c58946f7edb78535804c75f22.png";